import React, { useState } from 'react';

import axios from 'axios';
import Honeybadger from '@honeybadger-io/js';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

import { Spinner } from '../../../../shared/components/Spinner';
import { ERROR_GENERAL } from '../../../../shared/constants';
import { PAYMENT_INTENT } from '../../../shared/api';
import { WorkspaceLayout } from '../../../shared/components/Layout';

import styles from '../../../shared/styles/_layout.module.scss';

// TODO: Remove mock data.
const paymentDetails = {
  accountId: 1,
  priceCents: 99_00,
};

const Checkout = () => {
  const elements = useElements();
  const stripe = useStripe();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

  const confirmPaymentIntent = async (clientSecret) => {
    const cardElement = elements.getElement(CardElement);

    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    return { error, paymentIntent };
  };

  const createPaymentIntent = async () => {
    const requestBody = {
      account_id: paymentDetails.accountId,
      price_cents: paymentDetails.priceCents,
    };

    await axios
      // TODO: Investigate why JWT is not required.
      .post(PAYMENT_INTENT, requestBody)
      .then(async (response) => {
        const { paymentIntent, error } = await confirmPaymentIntent(
          response.data.client_secret
        );

        if (paymentIntent) {
          setSubmissionSuccessful(true);
        } else if (error) {
          setError(error.message);
        }
      })
      .catch((error) => {
        // Throw a new error that is the same as the original, but with a custom message.
        // The custom message will be the error message returned by the API. If the API
        // is unresponsive, the custom message will be null.
        const customError = new Error(error.message);
        Object.assign(customError, error);
        customError.customMessage = error.response?.data?.message;
        throw customError;
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError('');
    setSubmissionSuccessful(false);
    setLoading(true);

    try {
      await createPaymentIntent();
    } catch (error) {
      const errorMessage = error.customMessage || ERROR_GENERAL;
      setError(errorMessage);
      Honeybadger.notify(error);
    } finally {
      setLoading(false);
    }
  };

  const successAlert = (
    <div className="alert alert-success alert--form">Payment successful!</div>
  );

  const errorAlert = <div className="alert alert-danger alert--form">{error}</div>;

  return (
    <WorkspaceLayout>
      <h1 className={styles.dashboard__title}>Payment Form</h1>

      <div className={styles.dashboard__panel}>
        <form onSubmit={handleSubmit}>
          <CardElement />

          <button className="btn--primary" disabled={loading} type="submit">
            Pay
          </button>

          {loading && <Spinner />}

          {submissionSuccessful && successAlert}

          {error && errorAlert}
        </form>
      </div>
    </WorkspaceLayout>
  );
};

export default Checkout;
